import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_NOTIFICATIONS](state, payload) {
    state.notifications = payload;
  },
  [MutationsType.ADD_NOTIFICATION](state, payload) {
    state.notifications.push(payload);
  },
  [MutationsType.UPDATE_NOTIFICATION](state, payload) {
    let ind = (state.notifications || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0)
      Vue.set(state.notifications, ind, payload.value || { ...state.notifications[ind], ...payload.add_value });
  },
  [MutationsType.REMOVE_NOTIFICATION](state, payload) {
    let ind = (state.notifications || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.notifications, ind);

    ind = (state.notifications || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.notifications, ind);
  },
  [MutationsType.UNSUBSCRIBE_GET_ALL_NOTIFICATIONS](state, payload) {
    state.unsubscribeGetAllNotifications = payload;
  },
};
